<div class="select-context" aria-label="Map selection">
  <span class="selection-label">Selected</span>
  <div class="selection-groups">
    <span class="selection-chip" *ngFor="let selected of selections">
      <button type="button" class="selection-link br-interactive"
              (click)="featureSelected.emit(selected.feature.key)"
              [attr.aria-current]="selected.feature.key === activeFeatureKey ? 'page' : null"
              [attr.aria-label]="'View selected ' + selected.feature.name">
        <strong>{{ selected.count }}</strong> {{ selected.feature.name }}
      </button>
      <button type="button" class="selection-remove br-interactive"
              [attr.aria-label]="'Clear ' + selected.feature.name + ' selection'"
              [matTooltip]="'Clear ' + selected.feature.name"
              (click)="selected.feature.clearSelection()">×</button>
    </span>
  </div>
  <button type="button" class="ctx-btn" (click)="clearAll.emit()"
          aria-label="Clear all map selections">Clear</button>
</div>
